import classNames from 'classnames';
import type { DetailedHTMLProps, InputHTMLAttributes } from 'react';

type TextInputProps = DetailedHTMLProps<
  InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  error?: string;
  label?: string;
};

export function TextInput({
  className,
  error,
  label,
  placeholder,
  type = 'text',
  ...props
}: TextInputProps) {
  return (
    <div className={'text-input'}>
      {label && <label>{label}</label>}

      <input
        {...props}
        className={classNames(className)}
        placeholder={props.required ? `${placeholder}*` : placeholder}
        type={type}
        value={props.value}
      />

      {error && <p>{error}</p>}
    </div>
  );
}
